import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { QueryVhweb } from 'private-angular-vhframeworks';


@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit {
  isMobile: any
  constructor(
    public platform: Platform
  ) {
    if (platform.width() < 768) this.isMobile = true
    else if (platform.is("android") || platform.is("ios")) this.isMobile = false
    else this.isMobile = false
  }

  ngOnInit(): void { }

}
